export default {
	methods: 
    {		
		async getFiltrar()
		{			
			await this.getDataGet({route: 'get_aportesdescargar', data: 'descargar'})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
		},
		getPdf()
		{
			window.open( this.url+'/api/pdf/aportesdescargar?&token='+this.token,'_blank')
		},
	},
}